export default __webpack_public_path__ + "static/media/room-mel-main.3d70ad78.jpg";